export default __webpack_public_path__ + "static/media/FM.c916f997.svg";